import React__default, { Suspense } from 'react';
import { useTheme, useMediaQuery, Typography, Box, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Comparator from '../Comparator/index.js';
import DefaultIcon from '../DefaultIcon/index.js';
import NoResult from '../NoResult/index.js';
import ComparatorItem from './components/ComparatorItem/index.js';

var KFComparator = function KFComparator(_a) {
    var elementIds = _a.elementIds, actions = _a.actions, _b = _a.KIcon, KIcon = _b === void 0 ? DefaultIcon : _b;
    var t = useTranslation("refront-components").t;
    var theme = useTheme();
    var isLg = useMediaQuery(theme.breakpoints.up("lg"));
    if (!elementIds || elementIds.length === 0) {
        return (React__default.createElement(NoResult, null,
            React__default.createElement(Typography, { variant: "h4", color: "text.secondary" },
                React__default.createElement(KIcon, { fontSize: "large", className: "fa-images", sx: {
                        verticalAlign: "middle",
                        marginRight: function (theme) { return theme.spacing(3); }
                    } }),
                t("components.picture-viewer.noResult.label"))));
    }
    return (React__default.createElement(Comparator, { maxItemsPerRow: isLg ? 3 : 2 }, elementIds.map(function (elementId) {
        return (React__default.createElement(Suspense, { key: "suspense-".concat(elementId), fallback: React__default.createElement(Box, { sx: {
                    width: "100%",
                    height: "100%",
                    display: "grid",
                    gridTemplate: "minmax(0, 100%) 1fr / 1fr"
                } },
                React__default.createElement(CircularProgress, { sx: { justifySelf: "center", alignSelf: "center" } })) },
            React__default.createElement(ComparatorItem, { key: "item-".concat(elementId), elementId: elementId, actions: actions, KIcon: KIcon })));
    })));
};

export { KFComparator as default };
//# sourceMappingURL=index.js.map
